import {SectionUrl} from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/site-store/SiteStore';

export function getProductPageSectionUrl(sectionUrl: SectionUrl, baseUrl: string): string {
  if (sectionUrl.prefix) {
    return `${baseUrl}/${sectionUrl.prefix}`;
  }

  /* istanbul ignore next */
  return sectionUrl.url ?? baseUrl;
}

export function buildUrlWithHash(url: string, hash: string): string | null {
  try {
    const urlObj = new URL(url);
    urlObj.hash = hash;
    return urlObj.href;
  } catch /* istanbul ignore next */ {
    return null;
  }
}
